<template>
	<v-container class="outreach none-fluid link">
		<banner>Outreach</banner>
		<anchor-bar :data="data" />
		<br />
		<div class="mx-auto outreach-content">
			<v-expansion-panels v-model="pannels" multiple>
				<v-expansion-panel
					v-for="section in data"
					:key="section.title"
					:id="section.title.replace(/\s/gi, '-')"
				>
					<v-expansion-panel-header class="expansion-header">{{ section.title }}</v-expansion-panel-header>
					<v-expansion-panel-content class="expansion-content">
						<div
							v-for="content in section.content"
							:key="content"
							v-html="$sanitize(content)"
							class="expansion-subsection"
						></div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</div>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import AnchorBar from "../global/AnchorBar";
import { getAllOutreaches } from "../../service/outreach";

export default {
	components: {
		Banner,
		AnchorBar
	},
	data() {
		return {
			data: [],
			pannels: []
		};
	},
	mounted() {
		getAllOutreaches()
			.then(data => {
				this.data = data;
				for (let i = 0; i < data.length; ++i) {
					this.pannels.push(i);
				}
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>